var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsObject, IsOptional, ValidateNested } from 'class-validator';
import { ExerciseProgramForPatientListDto } from '../../exercise-programs/index.js';
import { TreatmentPlanPillDto } from '../../patient-list/index.js';
import { PatientForListUserDto } from './patient-for-list-user.dto.js';
export class PatientForPatientListDto {
    patient;
    exercisePrograms;
    treatmentPlans;
    static fromPatient(patient) {
        const dto = new PatientForPatientListDto();
        dto.patient = patient;
        return dto;
    }
}
__decorate([
    IsObject(),
    Expose(),
    Type(() => PatientForListUserDto),
    __metadata("design:type", Function)
], PatientForPatientListDto.prototype, "patient", void 0);
__decorate([
    IsArray(),
    Expose(),
    ValidateNested({ each: true }),
    Type(() => ExerciseProgramForPatientListDto),
    __metadata("design:type", Array)
], PatientForPatientListDto.prototype, "exercisePrograms", void 0);
__decorate([
    IsArray(),
    Expose(),
    IsOptional(),
    ValidateNested({ each: true }),
    Type(() => TreatmentPlanPillDto),
    __metadata("design:type", Array)
], PatientForPatientListDto.prototype, "treatmentPlans", void 0);
//# sourceMappingURL=patient-for-patient-list.dto.js.map